import { render, staticRenderFns } from "./EvrakGonderFormWizard.vue?vue&type=template&id=5e506563"
import script from "./EvrakGonderFormWizard.vue?vue&type=script&lang=ts"
export * from "./EvrakGonderFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports